<template>
  <div>
    <div class="container flex flex-wrap items-center flex-col m-auto px-4 lg:px-0 xl:px-0">
        <div class="flex pl-2 w-full lg:w-3/4 flex-wrap">
          <h1 class="mb-2 font-bold text-3xl text-black w-full text-center">{{ $t('messages.search.title') }}</h1>
        </div>
        <div class="mt-8 flex w-full justify-center flex-wrap">
          <div class="flex pl-2 w-full lg:w-3/4 flex-wrap">
            <div class="w-full lg:w-1/2 flex flex-wrap">
              <div class="w-full md:w-1/2 pr-0 md:pr-6 lg:pr-6">
                <p
                  class="font-semibold text-sm lg:text-base color-black mb-2"
                >{{ $t('messages.general.i_am') }}</p>
                <div class="dropdown">
                  <div class="relative w-full">
                    <div
                      class="w-full text-white font-semibold h-10 rounded py-3 px-4 text-xs border-none"
                       :class="[picked.value === 'female' ? 'bg-gradient-pink' : 'bg-gradient-blue']"
                    >
                      <p v-if="picked === ''">Genero</p>
                      <div v-else>
                        <i :class="picked.icon" class="mx-2 text-white"></i>
                        {{ $t(`messages.general.${picked.text}`) }}
                      </div>
                    </div>
                    <div class="absolute bg-gray-200 w-full z-50" v-show="isOpen">
                      <label
                        class="text-gray-700 py-2 px-4 bg-gray-300 block hover:bg-gray-400"
                        v-for="(item, index) in genre"
                        :key="index"
                        :for="index"
                        @click.self="isOpen = !isOpen"
                      >
                        <input
                          type="radio"
                          class="hidden"
                          name="gender"
                          :id="index"
                          :value="item"
                          v-model="picked"
                        />
                        <i :class="item.icon"></i>
                        {{ $t(`messages.general.${item.text}`) }}
                      </label>
                    </div>
                  </div>
                  <div
                    class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker"
                  ></div>
                </div>
              </div>
              <div class="w-full md:w-1/2 pl-0 md:pr-0 md:px-4 lg:pl-0 lg:pr-6 mt-4 md:mt-0">
                <p
                  class="py-1 text-base lg:text-base font-semibold color-black m-0"
                >{{ $t('messages.search.interested') }}</p>
                <div class="flex justify-center text-xs items-center rounded h-10 text-white"
                :class="[picked.value === 'female' ? 'bg-gradient-blue' : 'bg-gradient-pink']">
                  <i :class="icon_genre" class="mx-4"></i>
                  <p
                    class="w-full font-semibold  rounded leading-tight m-0"
                    v-text="$t(`messages.general.${res_genre}`)"
                  ></p>
                </div>
              </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/2 xl:w-1/2 pl-0 lg:pl-1">
              <p
                class="font-semibold text-sm lg:text-base xl:text-base mt-3 lg:mt-0"
              >{{ $t('messages.search.range') }}</p>
              <vue-slider
                class="mt-4 mb-6 mx-2"
                v-model="form.range_age"
                :tooltip="'always'"
                :tooltip-placement="['bottom', 'bottom']"
                :enable-cross="false"
                :min="18"
                color="#333"
              >
                <template v-slot:dot="{ value, focus }">
                  <div :class="['custom-dot', { focus }]"></div>
                </template>
                <template v-slot:tooltip="{ value, focus }">
                  <div :class="['custom-tooltip', { focus }]" class="font-semibold">{{ value }}</div>
                </template>
              </vue-slider>
            </div>
          </div>
          <div class="w-full flex mt-4 lg:w-3/4 flex-wrap h-full">
            <div
              class="w-full md:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col justify-between md:px-2 lg:px-2 xl:px-2 px-0"
            >
              <label
                class="font-semibold text-sm lg:text-base xl:text-base"
                for
              >{{ $t('messages.search.live_ideal_couple') }}</label>
              <SelectInput
                @add="addCountry"
                @remove="removeCountry"
                :withimages="true"
                itemkey="id"
                :multiple="true"
                :limit="10"
                imagekey="url"
                namekey="name"
                vvname="country"
                placeholder="Portugal, Honduras, etc"
                :items="orderedCountries"
                :locale="locale"
                :setbeginners="[257]"
                hasLocale
                sorted
              />
            </div>
            <div
              class="w-full md:w-1/2 lg:w-1/2 xl:w-1/2 w-1/2 flex flex-col justify-between md:px-2 lg:px-2 xl:px-2 px-0"
            >
              <label
                class="font-semibold text-sm lg:text-base xl:text-base"
                for
              >{{ $t('messages.general.order_by') }}</label>

              <SelectInput
                @selected="setFilter"
                itemkey="id"
                namekey="name"
                vvclass="form-group--error"
                :hasLocale="true"
                :locale="locale"
                :items="orden"
                :placeholder="$t('messages.search.order')"
              />
            </div>
          </div>
          <div class="w-full mt-8 lg:w-3/4 flex justify-center">
            <button
              class="lg:px-32 xl:px-32 mx-4 bg-blue-500 hover:bg-blue-700 no-underline text-white font-semibold rounded px-6 py-2"
              @click="restartSearch"
            >{{ $t('messages.general.start_search') }}</button>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import bus from "@/bus";
import SelectInput from "@/components/SelectInput.vue";

export default {
  name: "SearchForm",
  components: {
    SelectInput
  },
  data() {
    return {
      isOpen: false,
      res_genre: "",
      icon_genre: "",
      search: "",
      search_user: "",
      filter: [],
      selectedFilter: "",
      picked: {
        id: 1,
        icon: "icon-woman",
        text: "woman",
        value: "female",
        match: "man"
      },
      res_genre: "man",
      icon_genre: "icon-man",
      form: {
        range_age: [18, 80]
      },
      genre: [
        {
          id: 1,
          icon: "icon-woman",
          text: "woman",
          value: "female",
          match: "man"
        },
        {
          id: 2,
          icon: "icon-man",
          text: "man",
          value: "male",
          match: "woman"
        }
      ],
      value: [],
      selectedCountries: [],
      orderedCountries: [],
      users: [],
      orden: [
        {
          name: {
            es: "Ultima Modificación de Perfil",
            en: "Last profile modification"
          },
          id: "1"
        },
        { name: { es: "Ultima conexión", en: "Last connection" }, id: "2" },
        {
          name: {
            es: "Fecha de Creación de Perfil",
            en: "Profile creation date"
          },
          id: "3"
        },
        {
          name: {
            es: "Conectados ahora",
            en: "Online Now"
          },
          id: "4"
        }
      ],
      page: 1,
      list: [],
      infiniteId: +new Date(),
      isSearching: false,
      featured: []
    };
  },
  watch: {
    isOpen(isOpen) {
      if (isOpen) {
        document.addEventListener("click", this.closeDropdown);
      }
    }
  },
  async created() {
    await this.listCountries();
    await this.fetchUser();

    if (this.user.profile.gender) {
      const condition = this.user.profile.gender === "male" ? true : false;

      this.picked = {
        id: condition ? 2 : 1,
        icon: condition ? "icon-man" : "icon-woman",
        text: condition ? "man" : "woman",
        value: condition ? "male" : "female",
        match: condition ? "woman" : "man"
      };
      this.res_genre = condition ? "woman" : "man";
      this.icon_genre = condition
        ? "icon-woman"
        : "icon-man";
    }
    this.orderedCountries = this.countries.slice();

    this.featured = this.profiles.slice(0, 20);
  },
  computed: {
    ...mapState("profiles", ["profiles", "meta"]),
    ...mapState("auth", ["user"]),
    ...mapState("countries", ["countries"]),
    ...mapState("locale", ["locale"]),
    coverUrl() {
      if (this.users.picture) {
        const picture = this.users.pictures.filter(
          photo => photo.status === "approved" && photo.cover === 1
        );
        if (picture.length > 0) {
          return picture[0].url;
        }
        return "/storage/image/placeholder-user.jpg";
      }
      return "/storage/image/placeholder-user.jpg";
    }
  },
  methods: {
    ...mapActions("profiles", [
      "listSearchProfiles",
      "pagination",
      "showImages",
      "listProfiles",
      "storeSearchParams"
    ]),
    ...mapActions("countries", ["listCountries"]),
    ...mapActions("auth", ["fetchUser"]),
    infiniteHandler($state) {

      // Prevent scroll without clicking search button
      if (!this.isSearching) {
        $state.complete();
        return;
      }

      // If the users doesn't have an active subscription we set the limit to 100 users
      if (this.user.subscription_status !== 'active' && this.list.length >= 100) {
        $state.complete();
        return;
      }

      axios.get(`/api/web/user/profiles/search`, {
        params: {
          search_user: this.search_user,
          filter: this.filter,
          page: this.page,
          countries: this.selectedCountries.toString(),
          age: this.form.range_age.toString()
        },
      }).then(({ data }) => {
        if (data.data.length) {
          this.page += 1;

          const result = data.data.map(user => {
            let country = JSON.parse(user.profile_country);
            return {
              id: user.id,
              username: user.username,
              pictures: user.url,
              profile: {
                birthday: user.profile_birthday,
                phone_validate: user.profile_phone_validate,
                country: {
                  name: country[this.locale]
                }
              }
            }
          });

          this.list.push(...result);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    addCountry(value) {
      const specialValues = this.countries
        .filter(country => !country.iso)
        .map(country => country.id);

      const {
        name: { [this.locale]: country }
      } = this.countries.find(country => country.id === value);

      if (/world/gi.test(country) || /mundo/gi.test(country)) {
        // Make around the world country always visible
        this.orderedCountries = this.countries.filter(country => country.id === 257);
      } else if (specialValues.includes(value)) {
        this.orderedCountries = this.countries
          .slice()
          .filter(
            country =>
              !country.iso &&
              !/world/gi.test(country.name[this.locale]) &&
              !/mundo/gi.test(country.name[this.locale])
          );
      } else {
        this.orderedCountries = this.countries
          .slice()
          .filter(country => !!country.url);
      }

      this.selectedCountries.push(value);
    },
    removeCountry(value) {
      if (this.selectedCountries.length === 1) {
        this.orderedCountries = this.countries.slice();
      }
      this.selectedCountries = this.selectedCountries.filter(
        country => country !== value
      );
    },
    setFilter(value) {
      this.filter = value;
    },
    age(date) {
      return Math.floor((new Date() - new Date(date).getTime()) / 3.15576e10);
    },
    closeDropdown() {
      if (!event.target.closest(".dropdown")) {
        this.isOpen = false;
      }
    },
    countImages(images) {
      const count = images.filter(img => img.status === "approved");
      return count.length;
    },
    restartSearch() {
      const params = {
        lang: this.locale,
        range: this.form.range_age,
        filter: this.filter,
        selectedCountries: this.selectedCountries,
        countries: this.countries,
        orderedCountries: this.orderedCountries
      };

      this.storeSearchParams(params);

      this.$router.push({
        name: 'search',
        params
      });
    }
  }
}
</script>

<style lang="scss">
.bg-gradient-blue {
  background: linear-gradient(90deg, #1C4C91 0%, #3A91F9 100%);
}

.bg-gradient-pink {
  background: linear-gradient(90deg, #F98296 4.19%, #D8406C 100%);
}
</style>
